"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelToHash = exports.hashToModel = void 0;
const Tag_1 = require("@/common/cards/Tag");
const CardType_1 = require("@/common/cards/CardType");
const GameModule_1 = require("@/common/cards/GameModule");
const SearchIndex_1 = require("@/client/components/cardlist/SearchIndex");
const CardResource_1 = require("@/common/CardResource");
const MODULE_ABBREVIATIONS = {
    base: 'b',
    corpera: 'c',
    prelude: 'p',
    prelude2: '2',
    venus: 'v',
    colonies: 'C',
    turmoil: 't',
    community: '*',
    promo: 'r',
    ares: 'a',
    moon: 'm',
    pathfinders: 'P',
    ceo: 'l',
    starwars: 'w',
    underworld: 'u',
};
const TYPE_ABBREVIATIONS = {
    [CardType_1.CardType.EVENT]: 'r',
    [CardType_1.CardType.ACTIVE]: 'b',
    [CardType_1.CardType.AUTOMATED]: 'g',
    [CardType_1.CardType.PRELUDE]: 'p',
    [CardType_1.CardType.CORPORATION]: 'c',
    [CardType_1.CardType.CEO]: 'l',
    [CardType_1.CardType.STANDARD_PROJECT]: 's',
    [CardType_1.CardType.STANDARD_ACTION]: 'S',
    [CardType_1.CardType.PROXY]: '*',
    colonyTiles: 'C',
    globalEvents: 'e',
    milestones: 'm',
    awards: 'a',
    agendas: 't',
};
const TAG_ABBREVIATIONS = {
    [Tag_1.Tag.BUILDING]: '0',
    [Tag_1.Tag.SPACE]: '1',
    [Tag_1.Tag.SCIENCE]: '2',
    [Tag_1.Tag.POWER]: '3',
    [Tag_1.Tag.EARTH]: '4',
    [Tag_1.Tag.JOVIAN]: '5',
    [Tag_1.Tag.VENUS]: '6',
    [Tag_1.Tag.PLANT]: '7',
    [Tag_1.Tag.MICROBE]: '8',
    [Tag_1.Tag.ANIMAL]: '9',
    [Tag_1.Tag.CITY]: 'a',
    [Tag_1.Tag.MOON]: 'b',
    [Tag_1.Tag.MARS]: 'c',
    [Tag_1.Tag.WILD]: 'd',
    [Tag_1.Tag.EVENT]: 'e',
    [Tag_1.Tag.CLONE]: 'f',
    none: 'g',
    [Tag_1.Tag.CRIME]: 'h',
};
function hashToModel(windowLocationHash) {
    const model = {
        filterText: '',
        expansions: {
            base: true,
            corpera: true,
            prelude: true,
            prelude2: true,
            venus: true,
            colonies: true,
            turmoil: true,
            community: true,
            ares: true,
            moon: true,
            promo: true,
            pathfinders: true,
            ceo: true,
            starwars: true,
            underworld: true,
        },
        types: {
            event: true,
            active: true,
            automated: true,
            prelude: true,
            corporation: true,
            standard_project: true,
            standard_action: false,
            proxy: false,
            globalEvents: true,
            colonyTiles: true,
            milestones: true,
            awards: true,
            ceo: true,
            agendas: true,
        },
        tags: {
            building: true,
            space: true,
            science: true,
            power: true,
            earth: true,
            jovian: true,
            venus: true,
            plant: true,
            microbe: true,
            animal: true,
            city: true,
            moon: true,
            mars: true,
            crime: true,
            wild: true,
            event: true,
            clone: true,
            none: true,
        },
        resources: {
            none: true,
            [CardResource_1.CardResource.ANIMAL]: true,
            [CardResource_1.CardResource.MICROBE]: true,
            [CardResource_1.CardResource.FIGHTER]: true,
            [CardResource_1.CardResource.SCIENCE]: true,
            [CardResource_1.CardResource.FLOATER]: true,
            [CardResource_1.CardResource.ASTEROID]: true,
            [CardResource_1.CardResource.CAMP]: true,
            [CardResource_1.CardResource.PRESERVATION]: true,
            [CardResource_1.CardResource.DIRECTOR]: true,
            [CardResource_1.CardResource.DISEASE]: true,
            [CardResource_1.CardResource.GRAPHENE]: true,
            [CardResource_1.CardResource.HYDROELECTRIC_RESOURCE]: true,
            [CardResource_1.CardResource.RESOURCE_CUBE]: true,
            [CardResource_1.CardResource.DATA]: true,
            [CardResource_1.CardResource.SYNDICATE_FLEET]: true,
            [CardResource_1.CardResource.VENUSIAN_HABITAT]: true,
            [CardResource_1.CardResource.SPECIALIZED_ROBOT]: true,
            [CardResource_1.CardResource.SEED]: true,
            [CardResource_1.CardResource.AGENDA]: true,
            [CardResource_1.CardResource.ORBITAL]: true,
            [CardResource_1.CardResource.CLONE_TROOPER]: true,
            [CardResource_1.CardResource.TOOL]: true,
            [CardResource_1.CardResource.WARE]: true,
            [CardResource_1.CardResource.JOURNALISM]: true,
            [CardResource_1.CardResource.ACTIVIST]: true,
            [CardResource_1.CardResource.SUPPLY_CHAIN]: true,
        },
        searchIndex: SearchIndex_1.SearchIndex.create(),
        namesOnly: true,
        showAdvanced: false,
        vps: 0,
        sortOrder: 'a',
        showMetadata: true,
    };
    if (windowLocationHash.length > 1) {
        const hash = decodeURIComponent(windowLocationHash).slice(1);
        let remainder = [];
        [model.filterText, ...remainder] = hash.split('~');
        for (const e of remainder) {
            if (e.startsWith('m')) {
                const modules = e.slice(1);
                for (const module of GameModule_1.GAME_MODULES) {
                    const abbrev = MODULE_ABBREVIATIONS[module];
                    model.expansions[module] = modules.includes(abbrev);
                }
            }
            if (e.startsWith('t')) {
                const types = e.slice(1);
                for (const type of Object.keys(model.types)) {
                    const abbrev = TYPE_ABBREVIATIONS[type];
                    model.types[type] = types.includes(abbrev);
                }
            }
            if (e.startsWith('g')) {
                const tags = e.slice(1);
                for (const type of Object.keys(model.tags)) {
                    const abbrev = TAG_ABBREVIATIONS[type];
                    model.tags[type] = tags.includes(abbrev);
                }
            }
            if (e.startsWith('d')) {
                const metadata = e.slice(1);
                if (metadata.includes('f')) {
                    model.namesOnly = false;
                }
                if (metadata.includes('!')) {
                    model.showAdvanced = true;
                }
                if (metadata.includes('1')) {
                    model.sortOrder = '1';
                }
                if (metadata.includes('d')) {
                    model.showMetadata = false;
                }
            }
        }
    }
    return model;
}
exports.hashToModel = hashToModel;
function encode(vals, abbreviations) {
    const arry = Object.keys(vals);
    const text = arry.filter((e) => vals[e]).map((e) => abbreviations[e]).join('');
    return (text.length !== arry.length) ? text : undefined;
}
function encodeMetadata(model) {
    let text = '';
    if (model.namesOnly === false) {
        text += 'f';
    }
    if (model.showAdvanced === true) {
        text += '!';
    }
    if (model.sortOrder === '1') {
        text += '1';
    }
    if (model.showMetadata === false) {
        text += 'd';
    }
    return text;
}
function modelToHash(model) {
    const parts = {};
    parts.m = encode(model.expansions, MODULE_ABBREVIATIONS);
    parts.t = encode(model.types, TYPE_ABBREVIATIONS);
    parts.g = encode(model.tags, TAG_ABBREVIATIONS);
    parts.d = encodeMetadata(model);
    function tostring(key) {
        const content = parts[key] ?? '';
        return content === '' ? '' : `~${key}${content}`;
    }
    const text = model.filterText + tostring('m') + tostring('t') + tostring('g') + tostring('d');
    return '#' + encodeURIComponent(text);
}
exports.modelToHash = modelToHash;
